import { createFileRoute } from "@tanstack/react-router";
import { CursorCandles } from "@/components/CursorCandles";
import { Crosshair } from "@/components/Crosshair";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { TrendingBoard } from "@/components/rank/TrendingBoard";

export const Route = createFileRoute("/leaderboard")({
  head: () => ({
    meta: [
      { title: "Leaderboard — Highest ranked X accounts | Hoodrank" },
      {
        name: "description",
        content:
          "The Hoodrank leaderboard: X accounts ranked by follower quality — KOLs, funds, founders and projects in the Robinhood chain ecosystem.",
      },
      { property: "og:title", content: "Leaderboard — Hoodrank" },
      {
        property: "og:description",
        content: "Every ranked handle in one board: score, signal ratio and 7D/30D change.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: LeaderboardPage,
});

function LeaderboardPage() {
  return (
    <>
      <CursorCandles />
      <Crosshair />
      <SiteHeader />

      <main data-candles className="grid-paper min-h-[calc(100vh-4rem)]">
        <div className="shell py-14 md:py-20">
          <p className="label mb-6">Board · all ranked handles</p>
          <h1 className="max-w-[14ch] !text-[clamp(44px,7vw,104px)]">
            Leader<span className="hollow">board</span>
          </h1>
          <p className="mt-5 max-w-[52ch] text-[17px] text-ink-soft">
            Tracked handles ranked by 7D or 30D score momentum (from Sorsa score-changes), with tier
            filters.
          </p>

          <TrendingBoard />

          <p className="mono mt-6 text-[12px] text-ink-muted">
            Live via Hoodrank API (tracked Robinhood ecosystem handles).
          </p>
        </div>
      </main>

      <SiteFooter />
    </>
  );
}
